import { Controller } from "@hotwired/stimulus"

// Анимация цифр-метрик в hero. Запускается, когда блок попадает в viewport.
export default class extends Controller {
  static targets = ["value"]

  connect() {
    this.animated = false
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.animated) {
          this.animated = true
          setTimeout(() => this.animate(), 600)
          this.observer.disconnect()
        }
      })
    }, { threshold: 0.3 })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  animate() {
    this.valueTargets.forEach((el) => {
      const text = el.textContent
      const match = text.match(/^(\d+)/)
      if (!match) return
      const target = parseInt(match[1], 10)
      const suffix = text.replace(match[1], "")
      let current = 0
      const step = Math.max(1, Math.floor(target / 40))
      const interval = setInterval(() => {
        current += step
        if (current >= target) {
          current = target
          clearInterval(interval)
        }
        el.innerHTML = current + suffix
      }, 30)
    })
  }
}
